<template>
  <span v-if="label" :class="['version-status-badge', `version-status-badge--${props.version.status}`]">
    {{ label }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { Version } from "@/hooks/useVersions";

const props = defineProps<{ version: Version }>();

const label = computed(() => {
  switch (props.version.status) {
    case "live":
      return "Live";
    case "wip":
      return "WIP";
    default:
      return null;
  }
});
</script>

<style lang="scss" scoped>
.version-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: font("S");
  font-weight: 700;
  letter-spacing: 0.3px;
  min-width: 40px;
  white-space: nowrap;

  &--wip {
    background-color: #e3f2fd;
    color: #1565c0;
  }

  &--live {
    background-color: #e6f4ea;
    color: #1e7e34;
  }

  &--history {
    background-color: var(--vd-input-background-color);
    color: var(--vd-base-placeholder-color);
  }
}
</style>
